import { GetIconComponent } from '@bimser/icons';
import IconAI2 from '@bimser/icons/64/ai2';
import Styles from '../assets/styles.scss';
import { IPredefinedPromptsProps } from '../entities/IPredefinedPromptsProps';

const PredefinedPrompts: React.FC<IPredefinedPromptsProps> = props => {
	const renderPredefinedPrompts = () => {
		if (!props.items?.length) {
			return null;
		}

		return (
			<div className={Styles.predefinedPrompts}>
				{props.items?.map(item => {
					return (
						<div
							className={Styles.predefinedPrompt}
							key={item.key}
							onClick={() => props.onPromptSent(item.prompt)}
						>
							{GetIconComponent(item.icon)}
							{item.text}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<>
			<div className={Styles.magicIcon}>
				<IconAI2 />
			</div>
			{renderPredefinedPrompts()}
		</>
	);
};

export { PredefinedPrompts };
